var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.061 28.9391H52.1219C52.1219 43.2356 40.3575 55.0001 26.061 55.0001C11.7644 55.0001 0 43.2356 0 28.9391C0 28.8566 0 28.7741 0 28.6917L26.061 28.9391Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 21.0174C18.3062 21.0174 23.0111 16.3125 23.0111 10.5087C23.0111 4.70491 18.3062 0 12.5024 0C6.69856 0 1.99365 4.70491 1.99365 10.5087C1.99365 16.3125 6.69856 21.0174 12.5024 21.0174Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.622 21.0174C45.4258 21.0174 50.1307 16.3125 50.1307 10.5087C50.1307 4.70491 45.4258 0 39.622 0C33.8182 0 29.1133 4.70491 29.1133 10.5087C29.1133 16.3125 33.8182 21.0174 39.622 21.0174Z",
    fill: "#F89B60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1219,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.417916c372d8b6796ade9c2358fbeb64.svg";
export { ForwardRef as ReactComponent };